<template lang="html">
    <section class="my-order col-md-12" v-if="order != null">
        <loader :loading="loading"></loader>
        <div class="orderDeleted" v-if="order.status.reference_status === 'order_deleted'"><OrderDeleted :orderData="order"></OrderDeleted></div>

        <div v-show="order.status.reference_status !== 'order_deleted'">
            <div class="order-status" v-if="order.status">
                <span class="label"> {{ $t("orders.labelStatus") }} :</span>
                <span class="status"><i class="fas fa-file-invoice-dollar"></i> {{ getTranslate(order.status.name) }}</span>
            </div>
            <div class="row">
                <div class="col-lg-12 my-order-header"><order-header class="my-order-header"></order-header></div>
                <div class="my-order-list col-lg-9 col-md-8 col-xs-12"><OrderMain :orderData="order"></OrderMain></div>
                <div class="my-order-recap col-lg-3 col-md-4 col-xs-12">
                    <!-- <orderSideBloc :title="$t('orders.storeInformation.title')"> <order-information></order-information> </orderSideBloc> -->
                    <orderSideBloc :title="$t('orders.deliveryAddress.title')">
                        <delivery-address :dataDeliveryAdress="order" :key="order.id"></delivery-address>
                    </orderSideBloc>
                    <orderSideBloc :title="$t('orders.payments.title')" v-if="havePaymentRights">
                        <order-payments :dataPurchaseOrderNumber="order.purchaseOrderNumber" :key="order.id"></order-payments>
                    </orderSideBloc>
                    <orderSideBloc :title="$t('orders.orderWindow.title')"> <orderWindows></orderWindows> </orderSideBloc>
                    <!--
                        <orderSideBloc :title="$t('orders.buyerInformation.title')"> <order-buyer-information></order-buyer-information> </orderSideBloc>
                    -->
                    <!-- <orderSideBloc :title="$t('orders.people.title')"> <order-people-associated></order-people-associated> </orderSideBloc> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapActions, mapGetters} from 'vuex'
import deliveryAddress from "./order-common/delivery-address"
import orderInformation from "./order-common/order-information";
import orderPayments from "./order-common/order-payments";
import orderBuyerInformation from "./order-common/order-buyer-information";
import orderPeopleAssociated from "./order-common/order-people-associated";
import orderHeader from "./order-common/order-header";
import orderSideBloc from "./order-side-bloc";
import orderWindows from "./order-common/order-windows";
import OrderMain from "./OrderMain/OrderMain";
import OrderDeleted from "./OrderMain/OrderDeleted";
import currentBrand from "@/services/currentBrand";
import loader from "@/components/loader/loader";
import cacheService from "@/services/cache";

export default {
    name: 'my-order',
    components: {
        deliveryAddress,
        orderHeader,
        orderPeopleAssociated,
        orderBuyerInformation,
        orderPayments,
        orderInformation,
        orderSideBloc,
        OrderMain,
        orderWindows,
        OrderDeleted,
        loader
    },
    props: [],
    mounted() {
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        getBrandLocalStorageList (brandId) {
            let brandList =  cacheService.getBrands();
            return brandList.find(brand => brand.id == brandId ) || false;
        },
        ...mapActions("order/details/", ['fetchOrder', 'getShippingMethods','fetchOrderWithCustomInfos' ]),
        ...mapActions("brand/", ["populate"]),
        ...mapActions("currentUser/", ["populateInfo"]),
        async loadOrder () {
            this.loading = true;
            let brandId = this.$route.query.brandId;
            let zoneId = this.$route.query.zoneId;

            let orderInfos  = {
                orderId: this.$route.params.id,
                infos : (brandId && zoneId) ? {brandId, zoneId} : undefined};
            try {
                await this.fetchOrder(orderInfos);
                if (orderInfos.infos)
                    currentBrand.save(this.getBrandLocalStorageList(orderInfos.infos.brandId), orderInfos.infos.zoneId, this.$accessUser, true)
                    this.populate();
                    this.populateInfo();
                this.getShippingMethods()
            }
            catch (e) {
                if (e.code == 404) {
                    this.$router.push({name: "error404"})
                }
                else {
                    this.dialogError(e.message);
                }
            }
            finally {
                this.loading = false;
            }
        }
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        }),
        havePaymentRights() {
            return this.hasClientAccess(
                "orders_manager",
                ...(this.AccessUser.CONTRIBUTE)
            )
        },
    },
    created() {
        this.loadOrder();
    }
}
</script>

<style lang="scss">
@import "../../assets/css/themes.scss";

.btn {
    &-orders {
        @extend %primary-text;
        @extend %primary-background;
        @extend %primary-border;
        border-radius: 2rem;
        padding: 0.65rem 1.7rem;
        font-size: 1.2rem;
        text-decoration: none;
        text-transform: uppercase;
    }
}

.my-order {
    &-header {
        margin-bottom: 10px;
    }
    & .order-status {
        text-align: right;
        margin: 20px 0;
        @media only screen and (max-width: 767px) {
            text-align: left;
        }
        & .label {
            @extend %primary-text;
            font-size: 13px;
            font-family: "oswald-regular", sans-serif;
        }
        & .status {
            background-color: $color4;
            border-radius: 15px;
            padding: 5px 20px 5px 10px;
            color: white;
            font-size: 12px;
            & svg {
                margin-right: 5px;
            }
        }
    }
    &-list {
        & .sectionorder {
            background-color: white;
            border: 1px solid $color4;
            @media only screen and (max-width: 767px) {
                margin-bottom: 15px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// myOrder.vue?61609ca4